export default {
    props: {
        value: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        price() {
            return this.value
                ? this.value.children.reduce((accumulator, currentValue) => {
                      return (
                          (accumulator.price
                              ? (accumulator?.quantity || 1) *
                                this.value.quantity *
                                accumulator.price
                              : accumulator) +
                          (currentValue?.quantity || 1) * this.value.quantity * currentValue.price
                      )
                  }, this.value.price * this.value.quantity)
                : undefined
        },

        originalPrice() {
            return this.value
                ? this.value.children.reduce((accumulator, currentValue) => {
                      const aPrice = accumulator.original_price || accumulator.price
                      const cPrice = currentValue.original_price || currentValue.price
                      return (
                          (aPrice
                              ? (accumulator?.quantity || 1) * this.value.quantity * aPrice
                              : accumulator) +
                          (currentValue?.quantity || 1) * this.value.quantity * cPrice
                      )
                  }, (this.value.original_price || this.value.price) * this.value.quantity)
                : undefined
        },
        sortedOptions() {
            return Object.values(
                this.sortNull(this.value.children, 'group_position').reduce((p, c) => {
                    if (!p[c.group_position]) p[c.group_position] = []
                    p[c.group_position].push(c)
                    return p
                }, {})
            ).map((group) => this.sortNull(group, 'meal_option_position'))
        },
    },
}
